import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { globalUser } from './helpers/globalFields';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { LoginService } from './services/login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private loginService: LoginService, private router: Router) {}

  canActivate(): Observable<boolean> {
    return globalUser.getAuthStatus().pipe(
      take(1),
      map(isAuthenticated => {
        if (!isAuthenticated) {
          this.router.navigate(['/login']);
          return false;
        }
        return true;
      })
    );
  }
}